import _ from 'lodash'
import moment from 'moment'
import { ARTICLE_PLAGIARISM_CHECK_STATUSES } from '../enums/ArticlePlagiarismCheck'

export function isPlagiarismChecking(plagiarismCheck) {
  const plagiarismCheckStatus = _.get(plagiarismCheck, 'status', null)
  if (!_.isEqual(plagiarismCheckStatus, ARTICLE_PLAGIARISM_CHECK_STATUSES.CHECKING)) {
    return false
  }

  const plagiarismCheckUpdatedAt = _.get(plagiarismCheck, 'updatedAt', null)
  return _.isNil(plagiarismCheckUpdatedAt) || moment().diff(moment(plagiarismCheckUpdatedAt), 'hours') < 1
}
